import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';


@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {

  constructor(
    private readonly router: Router,
    private readonly usersService: UserService
  ) {
  }

  async ngOnInit() {
    const result = await this.usersService.logout();
    console.log(`logout result: ${JSON.stringify({result})}`);
    await this.router.navigate(['/'], {replaceUrl: true});
  }

}
